(function(){
  // 轻量节流，避免频繁触发
  var ticking = false;

  function fmtNum(x){ return x.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function renderUSDTMiniCart(){
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(function(){
      try {
        var row   = document.getElementById('mini-usdt-row');
        var amtEl = document.getElementById('mini-usdt-amount');
        var note  = document.getElementById('mini-usdt-note');
        if(!row || !amtEl || !note){ ticking = false; return; }

        var cents = parseInt(row.dataset.totalCents || '0', 10);
        var rate  = parseFloat(row.dataset.rate || '0.999');
        if(!(cents >= 0) || !(rate > 0)){ ticking = false; return; }

        var usd  = cents / 100.0;
        var usdt = usd / rate;
        var usdtStr = (Math.ceil(usdt * 100) / 100).toFixed(2);

        // 若数值未变化则不重复写入（避免 observer 连锁）
        if (amtEl.getAttribute('data-rendered') !== usdtStr) {
          amtEl.textContent = fmtNum(usdtStr) + ' USDT';
          amtEl.setAttribute('data-rendered', usdtStr);
        }

        // 多语言模板：从隐藏模板节点读取；无则兜底
        var tplNode = document.getElementById('mini-usdt-note-tpl');
        var tpl = tplNode ? tplNode.textContent : '(Based on 1\u00A0USDT = %{rate}\u00A0USD)';
        var noteHtml = tpl.replace('%{rate}', rate);
        if (note.getAttribute('data-rendered') !== noteHtml) {
          note.innerHTML = noteHtml;
          note.setAttribute('data-rendered', noteHtml);
        }
      } finally {
        ticking = false;
      }
    });
  }

  // 1) 首次 DOM 就绪时跑一次（主题编辑器预览也能渲染）
  document.addEventListener('DOMContentLoaded', renderUSDTMiniCart);

  // 2) 迷你购物车打开（body 会加类名）时跑一次
  try {
    var bodyObs = new MutationObserver(function(){
      if (document.body.classList.contains('header-mini-cart-open')) {
        renderUSDTMiniCart();
      }
    });
    bodyObs.observe(document.body, { attributes:true, attributeFilter:['class'] });
  } catch(e) {}

  // 3) 仅在 Drawer DOM 变化时、且我们的行已出现时才渲染（避免无限循环）
  try {
    var drawer = document.getElementById('HeaderMiniCart');
    if (drawer) {
      var drawerObs = new MutationObserver(function(muts){
        // 只在 mini-usdt-row 存在时触发一次渲染
        if (document.getElementById('mini-usdt-row')) {
          renderUSDTMiniCart();
        }
      });
      drawerObs.observe(drawer, { childList:true, subtree:true });
    }
  } catch(e) {}

  // 4) 一些主题会派发的事件（若没有也没影响）
  ['cart:updated','drawer:open','cart-drawer:open'].forEach(function(evt){
    document.addEventListener(evt, renderUSDTMiniCart, true);
  });
})();
